import { render, staticRenderFns } from "./update-colors.vue?vue&type=template&id=1e29bbf1&"
import script from "./update-colors.vue?vue&type=script&lang=js&"
export * from "./update-colors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports